<template>
  <div
    class="skeleton__availability"
  >
    <div class="skeleton__availability__header">
      <Skeleton class="skeleton__availability__header" />
    </div>
    <Skeleton
      class="skeleton__availability__subheader"
      v-if="isEditCart"
    />

    <Skeleton class="skeleton__availability__text" />
    <Skeleton class="skeleton__availability__subheader" />

    <div class="skeleton__availability__input">
      <Skeleton class="skeleton__availability__input__forms" />
      <Skeleton class="skeleton__availability__input__forms" />
    </div>
    <Skeleton
      class="skeleton__availability__text"
      v-if="!isEditCart"
    />

    <div
      class="skeleton__availability__extra-fields"
      v-if="!isEditCart"
    >
      <Skeleton class="skeleton__availability__extra-fields__forms" />
      <Skeleton class="skeleton__availability__extra-fields__forms" />
    </div>
    <div
      class="skeleton__availability__extra-fields"
      v-if="!isEditCart"
    >
      <Skeleton class="skeleton__availability__extra-fields__forms" />
      <Skeleton class="skeleton__availability__extra-fields__forms" />
    </div>    <div
      v-for="n in 3"
      :key="n"
      class="skeleton__availability__text-labels"
    >
      <Skeleton class="skeleton__availability__text-labels__text-label" />
      <Skeleton class="skeleton__availability__text-labels__text-value" />
    </div>
    <div class="skeleton__availability__buttons">
      <Skeleton
        v-if="isEditCart"
        class="skeleton__availability__buttons__request"
        :shape="'rectangle'"
      />
      <Skeleton
        class="skeleton__availability__buttons__buy"
        :shape="'rectangle'"
      />
    </div>
    <div class="skeleton__availability__table">
      <price-scales-skeleton v-if="isEditCart" />
    </div>
  </div>
</template>
<script>
import {Skeleton} from '@progress/kendo-vue-indicators'
import PriceScalesSkeleton from './PriceScalesSkeleton.vue'

export default {
  components: {
    Skeleton,
    PriceScalesSkeleton
  },
  props: {
    isEditCart: {
      type: Boolean,
      default () {
        return false
      }
    }
  }
}
</script>
